import React, { memo } from 'react'
import { useFormContext } from 'react-hook-form'

import styled from '@emotion/styled'

import { Input } from '@surglogs-app/ui'
import { DefaultFormField } from '@surglogs-app/ui.form'

import { useAccountSettingsTranslation } from '../services'

const StyledFormField = styled(DefaultFormField)`
  margin-bottom: ${({ theme }) => theme.ui.spacings.lg};
`

export const SettingsUserEditPinModalFormPassword = memo(() => {
  const { t } = useAccountSettingsTranslation()
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext()

  return (
    <StyledFormField
      {...{
        t,
        name: 'password',
        children: t('passwordLabel'),
        errors,
      }}>
      <Input
        {...{
          ...register('password'),
          control,
          type: 'password',
          placeholder: t('passwordInputPlaceholder'),
        }}
      />
    </StyledFormField>
  )
})
